// NOTE: Not currently in use but didn't want to delete the file so we can revive later
import { Locales } from '@ratehub/base-ui';

import createBlogAuthorStaticProps from '../functions/createBlogAuthorStaticProps';
import withEnglishLocale from '../functions/withEnglishLocale';
import BlogAuthorPage from '../components/BlogAuthorPage';


const { getStaticPaths, getStaticProps } = createBlogAuthorStaticProps({
    locale: Locales.ENGLISH,
    fileName: 'blogAuthorEN',
    path: '/blog/author',
});

export default withEnglishLocale(BlogAuthorPage);
export { getStaticPaths, getStaticProps };
